<div class="row" *ngIf="(tableItem | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col">
                <label class="fw-bold">ID</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.tenderMaintenanceId" disabled />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Hours Before Pickup</label>
                <kendo-numerictextbox [min]="0" format="n0" [decimals]="0" [step]="1" [(ngModel)]="tableItem.hoursBeforePickup"></kendo-numerictextbox>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Minutes Between Tender Emails</label>
                <kendo-numerictextbox [min]="0" format="n0" [decimals]="0" [step]="1" [(ngModel)]="tableItem.minutesBetweenTenderEmails"></kendo-numerictextbox>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Tender Email Subject</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.tenderEmailSubject" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Tender Email Body</label>
                <textarea rows="7" class="form-control" [(ngModel)]="tableItem.tenderEmailBody"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Minutes Between Info Emails</label>
                <kendo-numerictextbox [min]="0" format="n0" [decimals]="0" [step]="1" [(ngModel)]="tableItem.minutesBetweenInfoEmails"></kendo-numerictextbox>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Info Email Subject</label>
                <input type="text" class="form-control" [(ngModel)]="tableItem.infoEmailSubject" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Info Email Body</label>
                <textarea rows="7" class="form-control" [(ngModel)]="tableItem.infoEmailBody"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Disclaimer</label>
                <textarea rows="7" class="form-control" [(ngModel)]="tableItem.disclaimer"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Header Text</label>
                <textarea rows="5" class="form-control" [(ngModel)]="tableItem.headerText"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">CC Email List</label>
                <span matTooltip="Enter multple emails separated by a comma (',')"><i class="far fa-question-circle text-primary"></i></span>
                <input type="text" class="form-control" [(ngModel)]="tableItem.ccEmailList" />
            </div>
        </div>
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
